import { forwardRef } from "react";

import {
  headerContentSlotVariants,
  headerContentVariants,
  headerRootVariants,
  type HeaderContentSlotVariants,
  type HeaderContentVariants,
  type HeaderRootVariants,
} from "./header.styles";

// -----------------------------------------------------------------------------

export type HeaderRootRef = React.ComponentRef<"header">;

export interface HeaderRootProps
  extends React.ComponentPropsWithoutRef<"header">, HeaderRootVariants {}

const HeaderRoot = forwardRef<HeaderRootRef, HeaderRootProps>(
  ({ children, className, layout, ...props }, ref) => {
    return (
      <header
        {...props}
        className={headerRootVariants({ className, layout })}
        ref={ref}
      >
        {children}
      </header>
    );
  },
);

HeaderRoot.displayName = "HeaderRoot";

export { HeaderRoot };

// -----------------------------------------------------------------------------

export type HeaderContentRef = React.ComponentRef<"div">;

export interface HeaderContentProps
  extends React.ComponentPropsWithoutRef<"div">, HeaderContentVariants {}

const HeaderContent = forwardRef<HeaderContentRef, HeaderContentProps>(
  ({ children, className, layout, ...props }, ref) => {
    return (
      <div
        {...props}
        className={headerContentVariants({ className, layout })}
        ref={ref}
      >
        {children}
      </div>
    );
  },
);

HeaderContent.displayName = "HeaderContent";

export { HeaderContent };

// -----------------------------------------------------------------------------

export type HeaderContentSlotsRef = React.ComponentRef<"div">;

export interface HeaderContentSlotsProps
  extends
    React.ComponentPropsWithoutRef<"div">,
    HeaderContentVariants,
    Omit<HeaderContentSlotVariants, "slot"> {
  slot0: NonNullable<React.ReactNode>;
  slot1?: React.ReactNode;
  slot2?: React.ReactNode;
}

const HeaderContentSlots = forwardRef<
  HeaderContentSlotsRef,
  HeaderContentSlotsProps
>(({ className, layout, slot0, slot1, slot2, ...props }, ref) => {
  return (
    <div
      {...props}
      className={headerContentVariants({ className, layout })}
      ref={ref}
    >
      <div className={headerContentSlotVariants({ layout, slot: "0" })}>
        {slot0}
      </div>
      <div className={headerContentSlotVariants({ layout, slot: "1" })}>
        {slot1}
      </div>
      <div className={headerContentSlotVariants({ layout, slot: "2" })}>
        {slot2}
      </div>
    </div>
  );
});

HeaderContentSlots.displayName = "HeaderContentSlots";

export { HeaderContentSlots };
